
import Vue from "vue";

let sliderUidCounter = 0;

export default Vue.extend({
  name: "SliderInput",
  props: {
    label: { type: String, required: true },
    value: { type: [Number, Object], required: true },
    min: { type: Number, required: true },
    max: { type: Number, required: true },
    step: { type: Number, default: 0.1 },
    unit: { type: String, default: "" },
  },
  created() {
    sliderUidCounter += 1;
    this.sliderUid = sliderUidCounter;
  },
  data() {
    return {
      sliderUid: 0,
    };
  },
  computed: {
    inputId(): string {
      return `slider-${this.sliderUid}-${this.label.replace(/\s/g, "-")}`;
    },
    /** Ref/ComputedRef が渡った場合にアンラップして数値にする */
    unwrappedValue(): number {
      const v = this.value;
      if (v != null && typeof v === "object" && "value" in v) {
        return Number((v as { value: unknown }).value);
      }
      return Number(v);
    },
    displayValue(): string {
      const v = this.unwrappedValue;
      return Number.isFinite(v) ? v.toFixed(1) : "";
    },
  },
  methods: {
    onInput(e: Event) {
      const el = e.target as HTMLInputElement;
      const num = parseFloat(el.value);
      if (Number.isFinite(num)) this.$emit("input", num);
    },
  },
});
